import { render, staticRenderFns } from "./MoleculeCreateEditAccess.vue?vue&type=template&id=6384dfa3&scoped=true&"
import script from "./MoleculeCreateEditAccess.vue?vue&type=script&lang=js&"
export * from "./MoleculeCreateEditAccess.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeCreateEditAccess.vue?vue&type=style&index=0&id=6384dfa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6384dfa3",
  null
  
)

export default component.exports